
import React from 'react';
import { Button, Flex, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionButton = motion(Button);
const MotionFlex = motion(Flex);

const Pagination = ({ productsPerPage, totalProducts, paginate, currentPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalProducts / productsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <MotionFlex 
      justify="center" 
      align="center" 
      mt={8}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <MotionButton
        onClick={() => paginate(currentPage - 1)}
        disabled={currentPage === 1}
        mr={2}
        bg="white"
        color="black"
        border="2px solid"
        borderColor="black"
        fontWeight="bold"
        _hover={{ bg: "gray.100" }}
        _active={{ bg: "gray.200" }}
        _disabled={{ 
          bg: "gray.300",
          borderColor: "gray.400",
          color: "gray.500",
          cursor: "not-allowed"
        }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        &laquo;
      </MotionButton>
      {pageNumbers.map(number => (
        <MotionButton
          key={number}
          onClick={() => paginate(number)}
          bg={currentPage === number ? 'black' : 'white'}
          color={currentPage === number ? 'white' : 'black'}
          border="2px solid"
          borderColor="black"
          fontWeight="bold"
          mx={1}
          _hover={{ 
            bg: currentPage === number ? 'gray.800' : 'gray.100'
          }}
          _active={{ 
            bg: currentPage === number ? 'gray.900' : 'gray.200'
          }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {number}
        </MotionButton>
      ))}
      <MotionButton
        onClick={() => paginate(currentPage + 1)}
        disabled={currentPage === pageNumbers.length}
        ml={2}
        bg="white"
        color="black"
        border="2px solid"
        borderColor="black"
        fontWeight="bold"
        _hover={{ bg: "gray.100" }}
        _active={{ bg: "gray.200" }}
        _disabled={{ 
          bg: "gray.300",
          borderColor: "gray.400",
          color: "gray.500",
          cursor: "not-allowed"
        }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        &raquo;
      </MotionButton>
    </MotionFlex>
  );
};

export default Pagination;
